/** Friendly labels for AlertAudience values from the API. */
const AUDIENCE_LABELS: Record<string, string> = {
  Internal: 'Internal',
  External: 'External',
  '0': 'Internal',
  '1': 'External'
};

const AUDIENCE_TONES: Record<string, string> = {
  Internal: 'internal',
  External: 'external',
  '0': 'internal',
  '1': 'external'
};

export function formatAlertAudience(raw?: string | number | null): string {
  if (raw === null || raw === undefined || raw === '') {
    return '';
  }

  const key = String(raw).trim();
  if (AUDIENCE_LABELS[key]) {
    return AUDIENCE_LABELS[key];
  }

  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim();
}

export function alertAudienceTone(raw?: string | number | null): string {
  if (raw === null || raw === undefined || raw === '') {
    return 'default';
  }

  const key = String(raw).trim();
  if (AUDIENCE_TONES[key]) {
    return AUDIENCE_TONES[key];
  }

  return key.toLowerCase() || 'default';
}
